import { atom } from "recoil";

export const loadgingState = atom({
  key: "losadingState",
  default: false,
});
